// src/config/menuConfig.js
export const departments = [
    { id: 'AdministrationPage', name: '行政办公室', iconClass: 'grid-item1' },
    { id: 'MembershipPage', name: '服务特色', iconClass: 'grid-item2' },
    { id: 'ActivityPage', name: '活动动态', iconClass: 'grid-item3' },
    { id: 'InternationalPage', name: '国际国内合作部', iconClass: 'grid-item4', specialClass: 'name4' },
    { id: 'ManagementPage', name: '分会管理部', iconClass: 'grid-item5', specialClass: 'name5' },
    { id: 'BonusPage', name: '福利部', iconClass: 'grid-item6', specialClass: 'name6' },
];